export enum TToastType {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
}
